import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { ApplicationSettings } from 'projects/lib_config/src/public-api';

fetch("./assets/config/appsettings.json", {method: 'GET', headers: {'pragma': 'no-cache', 'cache-control': 'no-cache' }})
  .then((res) => res.json())
  .then((config) => {
    if (environment.production) {
      enableProdMode();
    }
    
    platformBrowserDynamic([{ provide: ApplicationSettings, useValue: new ApplicationSettings().loadConfiguration(config) }]).bootstrapModule(AppModule)
      .catch(err => console.error(err));    
  });
